import {ConfigProvider} from "antd";
import koKR from "antd/locale/ko_KR";
import React from "react";

type Props = {
    children: React.ReactNode;
};
export const AntProvider = ({children}: Props) => (<ConfigProvider
    locale={koKR}
    theme={{
        components: {
            InputNumber: {
                paddingBlock: 10,
                paddingInline: 4,
            },
            Input: {
                activeBg: "#fff",
                borderRadiusSM: 7,
                borderRadius: 7,
                borderRadiusLG: 14,
                inputFontSizeLG: 16,
            }, Button: {
                // controlHeightLG: 60,
                fontWeight: 700,
                // width: "100%",
            }, Drawer: {
                colorBgContainer: "#fff",
            }, Modal: {
                contentBg: 'var(--black-85)',
            }, Message: {
                contentBg: 'var(--black-85)',
            }
        }, token: {
            fontFamily: 'Pretendard',
            fontWeightStrong: 700,
            borderRadius: 7,
            borderRadiusSM: 2,
            fontSizeSM: 12, // fontSize: 10,
            paddingXS: 4,
            borderRadiusLG: 12,
            colorBgBase: "#F0F2F5",
            controlHeightLG: 60,
            controlHeight: 40,
            controlHeightSM: 32, // Seed Token'
            colorPrimary: "#6e6eff",
            colorInfo: "#6e6eff",
            colorLink: "#5A5AFF", // Alias Token
            colorBgContainer: "#fff",
        },
    }}
>
    {children}
</ConfigProvider>);
